import { Action } from '../../../shared/xs/actions';

export class LogoutSuccessAction implements Action {
  static readonly type = '[Auth] Logout successful';
}
